import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../services/login/login.service';
import { User } from '../../models/login/user';
import { Observable } from 'rxjs/Rx';
import { FormsModule } from '@angular/forms';
import { global } from '../../models/global';
import {MatSnackBarComponent} from "../mat-snack-bar/mat-snack-bar.component";
declare var $:any;
@Component({
  selector: 'app-login-layout',
  templateUrl: './LoginLayout.Component.html'
})
export class LoginLayoutComponent  {
  constructor(){

  }


  
}
